import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "flexcontainer pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "row w-full justify-between flex" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_9 = { class: "flex flex-col h-full" }
const _hoisted_10 = { class: "flex-1 overflow-auto" }
const _hoisted_11 = { class: "popup-business popupbodycontainer" }
const _hoisted_12 = { class: "statuscontainer" }
const _hoisted_13 = { class: "formcontainer flex flex-col" }
const _hoisted_14 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_15 = { class: "w-full" }
const _hoisted_16 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_17 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_20 = { class: "w-full" }
const _hoisted_21 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_22 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_25 = { class: "w-full" }
const _hoisted_26 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_27 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_28 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_29 = { class: "w-3/6" }
const _hoisted_30 = { class: "w-3/6 leftspacing" }
const _hoisted_31 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_32 = { class: "w-full" }
const _hoisted_33 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_34 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_37 = { class: "col-md-6 w-6/12" }
const _hoisted_38 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_39 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_40 = { class: "col-md-6 w-6/12 leftspacing" }
const _hoisted_41 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_42 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_43 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_44 = { class: "col-md-6 w-6/12" }
const _hoisted_45 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_46 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_47 = { class: "col-md-6 w-6/12 leftspacing" }
const _hoisted_48 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_49 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_50 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_51 = { class: "w-6/12" }
const _hoisted_52 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_53 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_54 = { class: "w-6/12 leftspacing" }
const _hoisted_55 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = ["disabled"]
const _hoisted_58 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Select = _resolveComponent("Select")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[29] || (_cache[29] = _createElementVNode("div", { class: "title flex items-center" }, [
          _createElementVNode("h1", null, "Risk Master")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "btnprimary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.importDoc()))
          }, "Import"),
          _createElementVNode("input", {
            type: "file",
            class: "hidden",
            accept: ".xls,.xlsx",
            ref: "file",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fileReader($event)))
          }, null, 544),
          _createElementVNode("button", {
            class: "btnprimary flex items-center",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showPopupByAdd && _ctx.showPopupByAdd(...args)))
          }, "Add"),
          _createElementVNode("button", {
            class: _normalizeClass(["flex", _ctx.displayListInTable.length == 0?'btndisabled pointer-events-none':'filterButton']),
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
          }, [
            (_ctx.displayListInTable.length == 0)
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : (_openBlock(), _createElementBlock("img", _hoisted_5)),
            _cache[28] || (_cache[28] = _createTextVNode(" Filters "))
          ], 2)
        ])
      ]),
      _cache[55] || (_cache[55] = _createElementVNode("div", { class: "mt-3 text-xs" }, " Risk Master has been developed to help risk managers, claim adjusters, attorneys and safety managers to process, manage and analyze critical claims data. This data includes: general liability, workers' compensation, automotive liability, first reports of injury, reporting, policies, actuarial reporting and integrated disability management.This course helps you to understand what Information Security is, awareness on information security, different kinds of security breaches happening in daily life, physical security, email security, Knowing your responsibilities when dealing with Information Security. ", -1)),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_newTable, {
          tableRowData: _ctx.displayListInTable,
          headersData: _ctx.headers,
          openPopup: true,
          loadData: _ctx.dataLoading,
          tableProps: _ctx.tableProps
        }, null, 8, ["tableRowData", "headersData", "loadData", "tableProps"]),
        (_ctx.toolTipActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showRiskMasterPopup)
        ? (_openBlock(), _createBlock(_component_popup, {
            key: 0,
            popUp: _ctx.showRiskMasterPopup
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _cache[31] || (_cache[31] = _createElementVNode("h1", null, "Risk Master", -1)),
                _createElementVNode("button", {
                  class: "float-right text-3xl",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onCrossbtn()))
                }, _cache[30] || (_cache[30] = [
                  _createElementVNode("img", {
                    src: _imports_2,
                    class: "h-5 w-5 cursor-pointer"
                  }, null, -1)
                ]))
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _cache[33] || (_cache[33] = _createElementVNode("label", {
                                for: "Risk",
                                class: "controllabel"
                              }, "Risk", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                class: _normalizeClass(["inputboxstyling", {
                                                        'is-invalid': (_ctx.v$.riskThreatData.risk.$error||_ctx.displayErrorMessageOfRisk)
                                                    }]),
                                placeholder: "Risk",
                                onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.restrictCharacters('Risk'))),
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.riskThreatData.risk) = $event))
                              }, null, 34), [
                                [
                                  _vModelText,
                                  _ctx.riskThreatData.risk,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (_ctx.v$.riskThreatData.risk.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    (_ctx.v$.riskThreatData.risk.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_ctx.displayErrorMessageOfRisk == true)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[32] || (_cache[32] = [
                                      _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                    ])))
                                  : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _cache[35] || (_cache[35] = _createElementVNode("label", {
                                for: "Risk",
                                class: "controllabel"
                              }, "Threat", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                class: _normalizeClass(["inputboxstyling", {
                                                        'is-invalid': (_ctx.v$.riskThreatData.threatEvent.$error||_ctx.displayErrorMessageOfThreat)
                                                    }]),
                                placeholder: "Threat",
                                onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.restrictCharacters('Threat'))),
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.riskThreatData.threatEvent) = $event))
                              }, null, 34), [
                                [
                                  _vModelText,
                                  _ctx.riskThreatData.threatEvent,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (_ctx.v$.riskThreatData.threatEvent.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    (_ctx.v$.riskThreatData.threatEvent.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_ctx.displayErrorMessageOfThreat == true)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[34] || (_cache[34] = [
                                      _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                    ])))
                                  : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", null, [
                                _cache[37] || (_cache[37] = _createElementVNode("label", { class: "controllabel" }, "Risk Category", -1)),
                                _createVNode(_component_AutoComplete, {
                                  modelValue: _ctx.riskThreatData.riskCategory,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.riskThreatData.riskCategory) = $event)),
                                  suggestions: _ctx.searchRiskCategoryList,
                                  onComplete: _ctx.asyncRiskCategoryDataFind,
                                  onItemSelect: _ctx.selectedRiskCategoryOption,
                                  placeholder: "Risk Category",
                                  field: "label",
                                  class: _normalizeClass(["w-full", {
                                                            'p-invalid': _ctx.v$.riskThreatData.riskCategory.$error,
                                                            'has-options': _ctx.searchRiskCategoryList && _ctx.searchRiskCategoryList.length > 0,
                                                            'no-options': !_ctx.searchRiskCategoryList.length && _ctx.searchValue !== '',
                                                        }])
                                }, {
                                  empty: _withCtx(() => _cache[36] || (_cache[36] = [
                                    _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                                  ])),
                                  _: 1
                                }, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect", "class"]),
                                (_ctx.v$.riskThreatData.riskCategory.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                      (_ctx.v$.riskThreatData.riskCategory.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", null, [
                                _cache[39] || (_cache[39] = _createElementVNode("label", { class: "controllabel" }, "Threat Category", -1)),
                                _createVNode(_component_AutoComplete, {
                                  modelValue: _ctx.riskThreatData.threatCategory,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.riskThreatData.threatCategory) = $event)),
                                  suggestions: _ctx.searchThreatCategoryList,
                                  onComplete: _ctx.asyncthreatCategoryDataFind,
                                  onItemSelect: _ctx.selectedOption,
                                  placeholder: "Threat Category",
                                  field: "label",
                                  class: _normalizeClass(["w-full", {
                                                            'has-options': _ctx.searchThreatCategoryList && _ctx.searchThreatCategoryList.length > 0,
                                                            'no-options': !_ctx.searchThreatCategoryList.length && _ctx.searchValue !== '',
                                                        }])
                                }, {
                                  empty: _withCtx(() => _cache[38] || (_cache[38] = [
                                    _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                                  ])),
                                  _: 1
                                }, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect", "class"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("div", null, [
                                _cache[41] || (_cache[41] = _createElementVNode("label", { class: "controllabel" }, "Threat Source", -1)),
                                _createVNode(_component_AutoComplete, {
                                  modelValue: _ctx.riskThreatData.threatSource,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.riskThreatData.threatSource) = $event)),
                                  suggestions: _ctx.searchThreatSourceList,
                                  onComplete: _ctx.asyncthreatSourceDataFind,
                                  onItemSelect: _ctx.selectedThreatSourceOption,
                                  placeholder: "Threat Source",
                                  field: "label",
                                  class: _normalizeClass(["w-full", {
                                                            'has-options': _ctx.searchThreatSourceList && _ctx.searchThreatSourceList.length > 0,
                                                            'no-options': !_ctx.searchThreatSourceList.length && _ctx.searchValue !== '',
                                                        }])
                                }, {
                                  empty: _withCtx(() => _cache[40] || (_cache[40] = [
                                    _createElementVNode("span", { class: "text-xs" }, "No Source Found", -1)
                                  ])),
                                  _: 1
                                }, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect", "class"])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _cache[43] || (_cache[43] = _createElementVNode("label", {
                                for: "Risk",
                                class: "controllabel"
                              }, "Vulnerability", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                class: _normalizeClass(["inputboxstyling", {
                                                        'is-invalid': (_ctx.v$.riskThreatData.vulnerability.$error||_ctx.displayErrorMessageOfVulnerability)
                                                    }]),
                                placeholder: "Vulnerability",
                                onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.restrictCharacters('Vulnerability'))),
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.riskThreatData.vulnerability) = $event))
                              }, null, 34), [
                                [
                                  _vModelText,
                                  _ctx.riskThreatData.vulnerability,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (_ctx.v$.riskThreatData.vulnerability.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    (_ctx.v$.riskThreatData.vulnerability.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_ctx.displayErrorMessageOfVulnerability == true)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, _cache[42] || (_cache[42] = [
                                      _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                    ])))
                                  : _createCommentVNode("", true)
                            ])
                          ]),
                          _cache[50] || (_cache[50] = _createElementVNode("h1", { class: "upperspacing" }, "Impact Analysis", -1)),
                          _cache[51] || (_cache[51] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _cache[44] || (_cache[44] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.riskThreatData.business,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.riskThreatData.business) = $event)),
                                options: _ctx.dbBussiness,
                                optionLabel: "key",
                                optionValue: "value",
                                placeholder: "Please select one",
                                class: _normalizeClass(["w-full custom-multiselect userSelect", {
                                                        'is-invalid': _ctx.v$.riskThreatData.business.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.riskThreatData.business === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.riskThreatData.business !== ''
                                                    }]),
                                onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.calculateOverallImpact()))
                              }, null, 8, ["modelValue", "options", "class"]),
                              (_ctx.v$.riskThreatData.business.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                    (_ctx.v$.riskThreatData.business.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                              _cache[45] || (_cache[45] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.riskThreatData.financial,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.riskThreatData.financial) = $event)),
                                options: _ctx.dbFinancial,
                                optionLabel: "key",
                                optionValue: "value",
                                placeholder: "Please select one",
                                class: _normalizeClass(["w-full custom-multiselect userSelect", {
                                                        'is-invalid': _ctx.v$.riskThreatData.financial.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.riskThreatData.financial === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.riskThreatData.financial !== ''
                                                    }]),
                                onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.calculateOverallImpact()))
                              }, null, 8, ["modelValue", "options", "class"]),
                              (_ctx.v$.riskThreatData.financial.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                    (_ctx.v$.riskThreatData.financial.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _cache[46] || (_cache[46] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.riskThreatData.operations,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.riskThreatData.operations) = $event)),
                                options: _ctx.dbOperations,
                                optionLabel: "key",
                                optionValue: "value",
                                placeholder: "Please select one",
                                class: _normalizeClass(["w-full custom-multiselect userSelect", {
                                                        'is-invalid': _ctx.v$.riskThreatData.operations.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.riskThreatData.operations === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.riskThreatData.operations !== ''
                                                    }]),
                                onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.calculateOverallImpact()))
                              }, null, 8, ["modelValue", "options", "class"]),
                              (_ctx.v$.riskThreatData.operations.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                    (_ctx.v$.riskThreatData.operations.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_47, [
                              _cache[47] || (_cache[47] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.riskThreatData.legal,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.riskThreatData.legal) = $event)),
                                options: _ctx.dbLegal,
                                optionLabel: "key",
                                optionValue: "value",
                                placeholder: "Please select one",
                                class: _normalizeClass(["w-full custom-multiselect userSelect", {
                                                        'is-invalid': _ctx.v$.riskThreatData.legal.$error,
                                                        'inputboxstylingForSelectAtPopup': _ctx.riskThreatData.legal === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': _ctx.riskThreatData.legal !== ''
                                                    }]),
                                onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.calculateOverallImpact()))
                              }, null, 8, ["modelValue", "options", "class"]),
                              (_ctx.v$.riskThreatData.legal.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                    (_ctx.v$.riskThreatData.legal.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _cache[52] || (_cache[52] = _createElementVNode("h1", { class: "upperspacing" }, "Risk Analysis", -1)),
                          _cache[53] || (_cache[53] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("div", _hoisted_51, [
                              _cache[48] || (_cache[48] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.riskThreatData.likelihood,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.riskThreatData.likelihood) = $event)),
                                options: _ctx.dbLikelihood,
                                optionLabel: "key",
                                optionValue: "value",
                                placeholder: "Please select one",
                                class: _normalizeClass(["w-full custom-multiselect userSelect", {
                                                            'is-invalid': _ctx.v$.riskThreatData.likelihood.$error,
                                                            'inputboxstylingForSelectAtPopup': _ctx.riskThreatData.likelihood === '',
                                                            'stylingForInputboxstylingForSelectAtPopup': _ctx.riskThreatData.likelihood !== ''
                                                        }]),
                                onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.calculateOverallImpact()))
                              }, null, 8, ["modelValue", "options", "class"]),
                              (_ctx.v$.riskThreatData.likelihood.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                    (_ctx.v$.riskThreatData.likelihood.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                              _cache[49] || (_cache[49] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.riskThreatData.overallImpact,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.riskThreatData.overallImpact) = $event)),
                                options: _ctx.dbOverAllImpact,
                                disabled: "",
                                optionLabel: "key",
                                optionValue: "value",
                                placeholder: "Please select one",
                                class: "w-full custom-multiselect userSelect"
                              }, null, 8, ["modelValue", "options"])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _cache[54] || (_cache[54] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("button", {
                    disabled: _ctx.clickOnButton,
                    class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.onCancelbtn()))
                  }, "Reset", 10, _hoisted_56),
                  (_ctx.riskThreatData._id)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass(_ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'),
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.addOrUpdatethreat(_ctx.riskThreatData)))
                      }, "Update", 10, _hoisted_57))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass(_ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'),
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.addOrUpdatethreat(_ctx.riskThreatData)))
                      }, "Save", 10, _hoisted_58))
                ])
              ])
            ]),
            _: 1
          }, 8, ["popUp"]))
        : _createCommentVNode("", true)
    ])
  ]))
}